import { axiosInstance } from "../../../config/axios";
import endpoints from "../../../config/endpoints";
import { GenericResponse } from "../../../types";

export interface AdminUser {
	id: number;
	username: string;
	email: string;
	first_name: string;
	last_name: string;
	is_active: boolean;
	is_superuser: boolean;
	role_id: number;
	role_name: string;
	last_login: string;
	created_at: string;
}

export interface CreateAdminPayload {
	username: string;
	email: string;
	first_name?: string;
	last_name?: string;
	password: string;
	role_id: number;
	is_active?: boolean;
	is_superuser: boolean;
}

export const createAdmin = async (payload: CreateAdminPayload): Promise<AdminUser> => {
	const response = await axiosInstance.post<AdminUser>(
		`${import.meta.env.PROD ? endpoints().adminUsers.createAdmin : `/api/v1${endpoints().adminUsers.createAdmin}`}`,
		payload,
	);
	return response.data;
};

export const getAdmins = async (params: { page: number; limit: number }): Promise<GenericResponse<AdminUser[]>> => {
	const response = await axiosInstance.get<GenericResponse<AdminUser[]>>(
		`${import.meta.env.PROD ? endpoints().adminUsers.getAdmins : `/api/v1${endpoints().adminUsers.getAdmins}`}`,
		{ params },
	);
	return response.data;
};

export const getAdmin = async (id: number): Promise<AdminUser> => {
	const response = await axiosInstance.get<AdminUser>(
		`${import.meta.env.PROD ? endpoints(id).adminUsers.getAdmin : `/api/v1${endpoints(id).adminUsers.getAdmin}`}`,
	);
	return response.data;
};

export const updateAdmin = async (id: number, payload: Partial<CreateAdminPayload>): Promise<AdminUser> => {
	const response = await axiosInstance.put<AdminUser>(
		`${import.meta.env.PROD ? endpoints(id).adminUsers.updateAdmin : `/api/v1${endpoints(id).adminUsers.updateAdmin}`}`,
		payload,
	);
	return response.data;
};

export const deleteAdmin = async (id: number): Promise<void> => {
	await axiosInstance.delete(
		`${import.meta.env.PROD ? endpoints(id).adminUsers.deleteAdmin : `/api/v1${endpoints(id).adminUsers.deleteAdmin}`}`,
	);
};

